import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import MyAppBar from '../../components/MyAppBar';
import { CircularProgress, Container, Paper, Typography } from '@mui/material';
import AdvertisedInError from '../../components/AdvertisedInError';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

export default function F(props) {
  const { yearmonth } = useParams();
  const [year, month] = yearmonth.split('-');
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);

  useEffect(() => {
    const getCases = async () => {
      setLoading(true);
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/advertisedInError/${year}/${month}`
      );
      const casesResult = await response.json();
      console.log('casesResult:');
      console.log(casesResult);
      setCases(casesResult);
      setLoading(false);
    };
    getCases();
  }, [month, year]);

  return (
    <React.Fragment>
      <MyAppBar title='Appendix F - Advertised in Error' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          {loading && <CircularProgress />}
          {!loading && cases.length === 0 ? (
            <Typography variant='h6'>None</Typography>
          ) : (
            cases.map((c, i) => <AdvertisedInError permit={c} key={i} />)
          )}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
